<script setup lang="ts">
/**
 * Single mount point for dev-only tooling, rendered once from `App.vue`.
 *
 * `isDevToolsEnabled()` reads the build-time `__DEV_TOOLS__` literal, so on DEMO / PRODUCTION
 * and `--mode test` builds this branch folds away and Rollup drops the widget and its fixture
 * data from the output instead of shipping them as unreachable chunks.
 */
import { defineAsyncComponent, type Component } from "vue";
import { isDevToolsEnabled } from "@/composables/dev/useDevTools";

const DevAutofillWidget: Component | null = isDevToolsEnabled()
  ? defineAsyncComponent(async () => {
      // Registers all form presets as a side effect before the widget first renders.
      await import("@/utils/dev/presets");
      return import("@/components/dev/DevAutofillWidget.vue");
    })
  : null;
</script>

<template>
  <component
    :is="DevAutofillWidget"
    v-if="DevAutofillWidget"
  />
</template>
